import { PlanLimitConfigs, BillingCycleConfig } from "../common.ts";

export const TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE = "ANNUAL";
export const TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT = 300;

export const TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT = 801;

export const teamworkCollectionOfferingSkus = {
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
} as const;

export const teamworkCollectionOfferingSkusArray = Object.values(
    teamworkCollectionOfferingSkus
);

export const teamworkCollectionPlanLimitConfigs: PlanLimitConfigs[] = [
    {
        planName: "Premium",
        offeringSku: teamworkCollectionOfferingSkus.premium,
        recommendationLimit: 0,
        signupLimit: 50_000
    },
    {
        planName: "Enterprise",
        offeringSku: teamworkCollectionOfferingSkus.enterprise,
        recommendationLimit: 5000,
        signupLimit: 50_000
    }
];

export const teamworkCollectionBillingCycleConfig: BillingCycleConfig = {
    monthly: false,
    annual: true
};
